import { Injectable } from '@angular/core';
import { SDHttpService } from '../../Common/Routing/sd-http.service';

@Injectable({ providedIn: 'root' })
export class BuildTimestampService {
    constructor(private readonly _http: SDHttpService) {
    }

    resolve: (value: (void | PromiseLike<void>)) => void;
    reject: (reason?: any) => void;

    timestampCheck: Promise<void> = new Promise((res, rej) => {
        this.resolve = res;
        this.reject = rej;
    });

    private readonly _refreshRetryDelay = 60000;

    getTimestampCheckPromise(): Promise<void> {
        return this.timestampCheck;
    }

    async startCheck(): Promise<void> {
        this.timestampCheck = this._http.get('/app/build-timestamp.txt').then(ts=> {
            const runtimeTimestamp = parseInt(ts, 10);
            const weissmanBuildTimestamp = window['weissmanBuildTimestamp'];
            if (window['weissmanEnvironmentConfig'].developerMode) {
                console.log('Developer mode; skipping UI build time check');
            } else if (runtimeTimestamp !== weissmanBuildTimestamp) {
                // Looks like the UI is stale. Try to figure out the last time the page was refreshed
                const lastRefresh = sessionStorage['StateUIRefreshTime'];
                if (!lastRefresh || (new Date()).getTime() - parseInt(lastRefresh, 10) > this._refreshRetryDelay) {
                    console.log('Stale build detected; attempting refresh. Build time: ' + new Date(weissmanBuildTimestamp) +
                        '; runtime-detected build time: ' + new Date(runtimeTimestamp));
                    this.reject("Refreshing");
                    (<any>window.location).reload(true);
                    sessionStorage['StateUIRefreshTime'] = (new Date()).getTime();
                }
                else {
                    // We failed at failing
                    console.error('Build timestamp mismatch, and it appears a reload has already been tried. Build timestamp: ' +
                        weissmanBuildTimestamp + '; runtime value: ' + runtimeTimestamp);
                }
            } else {
                delete sessionStorage['StateUIRefreshTime'];
                console.log('Verified UI build up to date (build time: ' + new Date(weissmanBuildTimestamp) + ')');
            }
            this.resolve();
        }).catch((error)=> {
            this.reject(error);
        });

        this._http.initializeTimestampCheck(this.timestampCheck);
    }
}
